export default {
    featureFlags: {
        vdp: {
            stickyHeaderEnabled: true
        }
    },
    appDownload: {
        link: 'https://ma37m.app.goo.gl/rmZX',
        keyword: 'CARSCOUPON'
    },
    endpoints: {
        listings: {
            searchResults: '%%SEARCH_RESULTS_API_BASE_URL%%/search',
            matchCount: '%%SEARCH_RESULTS_API_BASE_URL%%/search-count',
            drv: '%%SEARCH_RESULTS_API_BASE_URL%%/drv',
            localOffers: '%%SEARCH_RESULTS_API_BASE_URL%%/local-offers',
            detail: '%%SEARCH_RESULTS_API_BASE_URL%%/listing/detail',
            adData: '%%SEARCH_RESULTS_API_BASE_URL%%/model-ad/'
        },
        consumerProfiles: {
            getVehicleStatus: '%%SEARCH_RESULTS_API_BASE_URL%%/saved-vehicles',
            savedVehicles: '%%SEARCH_RESULTS_API_BASE_URL%%/saved-vehicles',
            savedSearches: '%%SEARCH_RESULTS_API_BASE_URL%%/saved-searches',
            deleteVehicle: '%%SEARCH_RESULTS_API_BASE_URL%%/vehicle/listing',
            userSummary: '%%PROFILES_API_BASE_URL_GLOBAL%%/user-summary/',
            signUp: '%%PROFILES_API_BASE_URL_SECURE%%/signup/',
            logIn: '%%PROFILES_API_BASE_URL_SECURE%%/login/',
            logOut: '%%PROFILES_API_BASE_URL_GLOBAL%%/logout/',
            submitSignUp: '%%PROFILES_API_BASE_URL_SECURE%%/signup/cars/',
            submitSocialSignUp: '%%PROFILES_API_BASE_URL_SECURE%%/signup/social/',
            submitLogIn: '%%PROFILES_API_BASE_URL_SECURE%%/login/authenticate/',
            savedCars: '%%SEARCH_RESULTS_API_BASE_URL%%/saved-vehicles/',
            carSearch: '/for-sale/searchresults.action/',
            compare: '../compare/',
            favoriteCars: '../favorite-cars/',
            savedSearch: '../saved-searches/',
            carsIOwn: '/profile/ownedvehicles',
            carsIOwnGetSavedCars: '../ownedvehiclesbydeviceid/',
            carsIOwnRecalls: '/profile/ownedvehiclesrecalls/',
            carsIOwnConsumerReviews: '/profile/ownedvehiclesconsumerreviews/',
            accountUpdateEmail: '%%PROFILES_API_BASE_URL_SECURE%%/settings/update/email/',
            accountUpdateName: '%%PROFILES_API_BASE_URL_SECURE%%/settings/update/name/',
            accountUpdatePassword: '%%PROFILES_API_BASE_URL_SECURE%%/settings/update/password/',
            accountAuthenticate: '%%PROFILES_API_BASE_URL_SECURE%%/login/authenticate/',
            accountUploadImage: '%%PROFILES_API_BASE_URL%%/images'
        },
        coreshop: {
            vhr: '%%VEHICLE_HISTORY_REPORT_BASE_URL%%',
            vhrViewReport: '%%VEHICLE_HISTORY_REPORT_BASE_URL%%/coreshoppingsupportapi/1.0/listing/vhr/'
        },
        customer: {
            getCustomer: '%%CUSTOMER_DETAIL_API_BASE_URL%%'
        },
        als: {
            clickthru: '%%ACTIVITY_LOGGING_API_BASE_URL%%/clickthru',
            lead: '%%ACTIVITY_LOGGING_API_BASE_URL%%/lead',
            search: '%%ACTIVITY_LOGGING_API_BASE_URL%%/search',
            impression: '%%ACTIVITY_LOGGING_API_BASE_URL%%/impression'
        },
        lead: {
            captureWeb: '/leadCaptureWeb/submitInventoryLead',
            captureWebConnections: '/leadCaptureWeb/submitConnectionLead',
            captureRest: '/ajax/leadCaptureService/lead/REST/v1.0/'
        },
        contactAtOnce: {
            mobileTextConnect: '/ajax/coreshoppingsupportapi/1.0/log-dealer-mobile-text-connect'
        },
        smsPublish: {
            send: '%%SMS_PUBLISH_BASE_URL%%/send/'
        },
        uppDetails: '%%UPP_BASE_URL%%/detail/',
        mdc: {
            unifiedHeader: '%%MDC_USER_MGMT_BASE_URL%%/menu'
        },
        priceAdvisor: '/ajax/PriceAdvisorApi/1.0/'
    },
    cloudinary: {
        BASE_URL: '%%CLOUDINARY_URL%%',
        AVATAR_SMALL: 'avatar-small',
        AVATAR_LARGE: 'avatar-large',
        VEHICLE_X_SMALL: 'vehicle_photo_xs',
        VEHICLE_SMALL: 'vehicle_photo_sml',
        VEHICLE_MEDIUM: 'vehicle_photo_med',
        VEHICLE_LARGE: 'vehicle_photo_lrg',
        VEHICLE_X_LARGE: 'vehicle_photo_xl'
    },
    featureFlagStorageKey: 'feature-flags',
    searchSource: {
        GN_REFINEMENT: 'GN_REFINEMENT',
        GN_BREADCRUMB: 'GN_BREADCRUMB',
        SORT: 'SORT',
        PREMIER_NEW: 'PREMIER_NEW_LINK',
        PREMIER_USED: 'PREMIER_USED_LINK',
        PREMIER_CPO: 'PREMIER_CPO_LINK'
    },
    premierType: {
        PREMIER_NEW: 'NEW',
        PREMIER_USED: 'USED',
        PREMIER_USED_ALLMK: 'USED_ALLMK'
    },
    previousSrpUrlLocalStorageKey: 'srp-url',
    adSlotId: {
        shop: 6427
    },
    stockTypes: {
        NEW: 28880,
        USED: 28881,
        CPO: 28444
    },
    drv: {
        RPP: 8,
        SORT: 'price',
        SORT_DIRECTION: 'DESC',
        UNKNOWN_BS_ID: 29599,
        STORAGE_KEY: 'cars.similarVehicle',
        RADIUS: 30,
        CONFIG_ID: {
            SV: 0,
            CONQUEST: {
                BUDGET: 1
            }
        }
    },
    pagination: {
        MAX_PAGE: 50
    },
    tabIndex: {
        LEADFORM_TAB_INDEX: 2
    },
    defaultZip: 60604,
    defaultRadius: 30
};
